import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";
import {
	useGetAllNotificationsQuery,
	useGetNotificationsByDeviceIdQuery,
	useGetUsersNotificationsQuery,
} from "../../../Redux/service/Notifications/Notifications";
import { popupcontext } from "../../../context/Popupscontext";

export default function NotificationsMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedNotifications, setSelectedNotifications] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AdminNotifications, refetch: AdminNotifyRefetch } =
		useGetAllNotificationsQuery(undefined, { refetchOnMountOrArgChange: true });
	let { data: NotificationsVehicles, refetch: NotificationsVehiclesRefetch } =
		useGetNotificationsByDeviceIdQuery(vehicleId, {
			skip: !vehicleId,
			refetchOnMountOrArgChange: true,
		});
	let { data: UsersNotifications, refetch: UsersNotifyRefetch } =
		useGetUsersNotificationsQuery(userId, {
			skip: !userId,
			refetchOnMountOrArgChange: true,
		});

	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};

	const isFirstMount = useRef(true);
	useEffect(() => {
		if (AdminNotifications && UsersNotifications) {
			const merged = [...AdminNotifications, ...UsersNotifications];
			const unique = merged.filter(
				(item, index, self) => index === self.findIndex((t) => t.id === item.id)
			);
			setMergedData(unique);
		}
	}, [AdminNotifications, UsersNotifications]);
	useEffect(() => {
		if (
			isFirstMount.current ||
			AdminNotifyRefetch ||
			UsersNotifyRefetch ||
			NotificationsVehiclesRefetch
		) {
			if (mergedData?.length === 0) {
				setGroups(
					(
						AdminNotifications ||
						UsersNotifications ||
						NotificationsVehicles
					)?.map((i) => ({
						value: i.id,
						label: i.type,
					}))
				);
			} else {
				setGroups(
					mergedData?.map((i) => ({
						value: i.id,
						label: i.type,
					}))
				);
			}
		}
		isFirstMount.current = false;
	}, [
		AdminNotifications,
		AdminNotifyRefetch,
		UsersNotifications,
		UsersNotifyRefetch,
		NotificationsVehicles,
		NotificationsVehiclesRefetch,
		mergedData,
	]);

	useEffect(() => {
		if (type === "users") {
			if (UsersNotifications) {
				setSelectedNotifications(UsersNotifications?.map((i) => i.id));
			}
		} else if (type === "vehicles") {
			if (NotificationsVehicles) {
				setSelectedNotifications(NotificationsVehicles?.map((i) => i.id));
			}
		}
	}, [UsersNotifications, NotificationsVehicles, type]);

	useEffect(() => {
		if (isLinking) {
			if (type === "vehicles" && vehicleId) {
				NotificationsVehiclesRefetch();
			} else if (type === "users") {
				UsersNotifyRefetch();
			}
		}
	}, [
		NotificationsVehiclesRefetch,
		isLinking,
		vehicleId,
		type,
		UsersNotifyRefetch,
	]);
	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedNotifications((prev) => [...prev, value]);
						handleLink(value, "notification", "Notification");
					}}
					onDeselect={(value) => {
						setSelectedNotifications((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "notification", "Notification");
					}}
					value={selectedNotifications || ""}
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
